import _APIInstance from "@/config/configApi";
import _APIInstanceServer from "@/config/configApiServer";
import { API } from "@/constants/common";
import { Category } from "@/models/category";
import { paramsEX } from "@/models/Params";

class CategoryService {
  static async findAll(params?: Partial<paramsEX>): Promise<Category[]> {
    try {
      const response = await _APIInstance.get(`${API.CATEGORY_WP.GET_ALL}`, {
        params,
      });
      return response.data?.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  }

  static async findAllServer(params: Partial<paramsEX>): Promise<Category[]> {
    try {
      const response = await _APIInstanceServer.get(
        `${API.CATEGORY_WP.GET_ALL}`,
        {
          params,
        }
      );
      return response.data?.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  }
}

export default CategoryService;
